// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__jJIn0","Title":"style_Title__CERJz","LogoText":"style_LogoText__Uz2Zs","LogoCol":"style_LogoCol__yEFyH"};